import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const ContactCTA = () => {
  const { t } = useLanguage();
  
  return (
    <section className="bg-black py-16 md:py-24">
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-montserrat-bold text-2xl md:text-3xl text-white mb-4">
          {t('ctaTitle')}
        </h2>
        <p className="font-montserrat text-white/90 max-w-2xl mx-auto mb-8">
          {t('ctaSubtitle')}
        </p>
        <Link
          to="/contact"
          className="inline-block bg-white text-[#0b004c] font-montserrat-bold px-8 py-3 rounded hover:bg-gray-100 transition-colors duration-300"
        >
          {t('getQuote')}
        </Link>
      </div>
    </section>
  );
};

export default ContactCTA;
